var map = {
	"./bu_tag-text.png": "dc56",
	"./bu_tag.png": "0c9e",
	"./finished.png": "bb25",
	"./re_question_89.png": "ee48",
	"./rg_response_1.png": "c64f",
	"./rg_response_2.png": "5406",
	"./rg_response_3.png": "ea49",
	"./rg_response_4.png": "757a",
	"./second_cancel_btn.png": "71f4",
	"./second_confirm_layer.png": "192f",
	"./second_submit_btn.png": "5c88",
	"./start_btn.png": "9af7",
	"./survey_top.jpg": "694e",
	"./survey_top_new.jpg": "bf3d",
	"./testimg_qj.jpg": "919d",
	"./testimg_xg.jpg": "c83e",
	"./text_size.png": "0cde",
	"./text_size_layer.png": "fc3a",
	"./welcome_bg.jpg": "09ae",
	"./welcome_bg_new_qj.jpg": "8e42",
	"./welcome_bg_new_xg.jpg": "6a2d",
	"./welcome_bg_rg.jpg": "f878"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "29bc";